import React from 'react';

import { WarnModal } from '@/components/elements';

const ERROR_MODAL_TITLE = 'The server encountered an error processing the request';
const ERROR_MODAL_TEXT = `It does not appear to have affected your data, but we cannot process your request.
                          Our technical stuff has been automatically and will be looking into this with the utmost urgency.`;

interface Props {
  onSubmit: () => void;
  onSetVisible: (value: boolean) => void;  
  isAwaitMode?: boolean;
  disableAutomaticClosing?: boolean;
}

const LockboxErrorModal: React.FC<Props> = ({ onSubmit, onSetVisible, isAwaitMode, disableAutomaticClosing }) => {
  return (
    <WarnModal
      testId="lockbox-error-modal"
      visible
      onSetVisible={onSetVisible}
      header={ERROR_MODAL_TITLE}
      helptext={ERROR_MODAL_TEXT}
      buttonText="Close"
      onSubmit={onSubmit}
      submitButtonText="Try again"
      isAwaitMode={isAwaitMode}
      disableAutomaticClosing={disableAutomaticClosing}
    />
  );
};

export default LockboxErrorModal;
